var map = {
	"./teenpatt_en.png": "NDHt",
	"./teenpatt_th.png": "bbUI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZNXB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa ^\.\/teenpatt_.*\.png$
// module id = ZNXB
// module chunks = 1